import axios from "axios";
import dayjs from "dayjs";

export const getChartData = async (stockId: number, from?: string, to?: string) => {
    const res = await axios.get<{ [stockId: number]: [number, number, number, number, number, number?][] }>(`/API/chart_data/${stockId}`, {
        params: {
            to,
            from,
            type: "ohlcv",
        },
    });
    return res.data[stockId];
};

export const getChartDataNew = async (tradingitem: number, type: string, from?: string, to?: string, adjusted?: boolean) => {
    const res = await axios.get<{ [stockId: number]: [number, number, number, number, number, number?][] }>(`/interface/api/tradingitem/${tradingitem}/chart/${type}`, {
        params: {
            from_date: from ? from : dayjs().subtract(1, "year").format("YYYY-MM-DD"),
            to_date: to ? to : dayjs().format("YYYY-MM-DD"),
            // Dividend-adjusted prices (the chart's ADJ toggle).
            adjusted: adjusted ? 1 : undefined,
        },
    });
    return res.data[type];
};

// Date-stamped (label, text) marker rows — company-event overlays from the
// "Add data to chart" picker. Same response shape as the short-chart flags.
export const getFlagsData = async (url: string, from: string, to: string) => {
    const res = await axios.get(url, {
        params: {
            from_date: from,
            to_date: to,
        },
    });
    return res.data.data;
};

export const getChartDataCustomSeries = async (url: string, from?: string, to?: string) => {
    const arr = url.split(",");
    const res = await axios.get(arr[0], {
        params: {
            to_date: to,
            from_date: from,
        },
    });

    return res.data[arr[2]] || res.data.data;
};

export const getStockEndpoints = async (tradingItem: string, endpointKey?: string) => {
    const res = await axios.get(`/interface/api/ts_endpoints/tradingitem/${tradingItem}`);
    // const res = {
    //     Analysts: [
    //         {
    //             id: `${tradingItem}-analysts`,
    //             url: `/API/stock/${tradingItem}/estimates/eps/12mfwd`,
    //             dataName: "EPS (12m fwd)",
    //             dataKey: "estimates_eps_12mfwd",
    //             axis: "",
    //             sortKey: 0,
    //             color: 1,
    //             fieldDefinitions: ["time", "close"],
    //             visible: true,
    //         },
    //     ],
    //     Options: [
    //         {
    //             id: `${tradingItem}-options`,
    //             url: `/API/v2/id/${tradingItem}/options/options_pcr_history/`,
    //             dataName: "Open Interest Put / Call Ratio",
    //             dataKey: "PCR",
    //             axis: "pcr",
    //             sortKey: 33,
    //             color: 7,
    //             fieldDefinitions: ["time", "close"],
    //             visible: false,
    //         },
    //     ],
    //     Price: [
    //         {
    //             id: `${tradingItem}-price`,
    //             url: `/API/chart_data/${tradingItem}`,
    //             dataName: "Price",
    //             dataKey: tradingItem,
    //             axis: "",
    //             sortKey: 0,
    //             color: 1,
    //             fieldDefinitions: ["time", "open", "high", "low", "close"],
    //             visible: true,
    //         },
    //     ],
    //     "Short interest": [
    //         {
    //             id: `${tradingItem}-shorts-sieff`,
    //             url: `/API/${tradingItem}/shorts/sieff_v2/None/?format=flat`,
    //             dataName: "Days to cover 3m (on loan)",
    //             dataKey: "sieff_v2",
    //             visible: true,
    //             sortKey: 5.05,
    //             color: "#d87b26",
    //             lineStyle: "Solid",
    //             axis: "dtc",
    //             fieldDefinitions: ["time", "close"],
    //         },
    //         {
    //             id: `${tradingItem}-shorts-dtc_onl`,
    //             url: `/interface/api/short/tradingitem/${tradingItem}/short/dtc_onl/3m/`,
    //             dataName: "Days to cover 3m (on loan)",
    //             dataKey: "dtc_onl_3m",
    //             visible: true,
    //             sortKey: 5.05,
    //             color: "#d87b26",
    //             lineStyle: "Solid",
    //             axis: "dtc",
    //             fieldDefinitions: ["time", "close"],
    //         },
    //         // Si se requiere agregar más endpoints, se pueden incluir aquí usando la misma lógica.
    //     ],
    // };

    if (!endpointKey) {
        return res.data;
    } else {
        return res.data[endpointKey];
    }
};

export const getNonStockEndpoints = async () => {
    const res = await axios.get("/interface/api/ts_endpoints/generic");

    return res.data;
};
